<!--
  Breadcrumb walks the legacy ui-router state path:
    Tax Year > Return Type > Tax Payer Name [> Parent State] > Page Label
  The last two segments (parent + page) come from the active sidebar entry
  and update on every navigation — mirrors legacy behavior where moving to
  `submissions-dasboard.submission.data.addEdit` showed "... > Data > Add / Edit".
-->
<!-- <div class="ap-pl-spacing-3 ap-pr-spacing-3 bread-crumbs">
  <div class="top-bar">
    <span class="Appkit4-icon icon-like-outline icon-transform-outline structure"></span>
    <span class="structure">
      {{ taxYear }}
      <span class="Appkit4-icon icon-right-chevron-outline"></span>
      {{ submission.RETURN_TYPE }}
      <span class="Appkit4-icon icon-right-chevron-outline"></span>
      {{ submission.TAX_PAYER_NAME }}
      <ng-container *ngIf="currentParentLabel">
        <span class="Appkit4-icon icon-right-chevron-outline"></span>
        {{ currentParentLabel }}
      </ng-container>
      <ng-container *ngIf="currentMenuLabel">
        <span class="Appkit4-icon icon-right-chevron-outline"></span>
        <ng-container *ngIf="childSubStateLabel; else activeMenuTpl">
          {{ currentMenuLabel }}
        </ng-container>
        <ng-template #activeMenuTpl>
          <strong class="bread-crumbs-active">{{ currentMenuLabel }}</strong>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="childSubStateLabel">
        <span class="Appkit4-icon icon-right-chevron-outline"></span>
        <strong class="bread-crumbs-active">{{ childSubStateLabel }}</strong>
      </ng-container>
    </span>
  </div>
</div> -->
<div class="grid-container">
  <div class="row bg-white" id="body-row">
    <!--
      Sidebar items mirror the legacy ui-router child states defined in
      ui/app/components/efile/efile.js (`submissions-dasboard.submission.*`):
        Dashboard               -> .dashboard
        Add / Edit              -> .data.addEdit             (subState: 'add-edit')
        List of Overrides       -> .overrides                (subState: 'overrides')
        PDF Upload              -> .pdfupload                (subState: 'pdf-upload')
        Return Review           -> .return-review            (subState: 'return-review')
        Send Return to IRS      -> .submit                   (subState: 'submit')
        Upload Consol XML       -> .xmlUploadKeyId           (subState: 'xml-upload')
        Download 8453 Pdf       -> EfileFactory.download8453cPdf  (action, no state)
        Download 8879 Pdf       -> EfileFactory.download8879cfPdf (action, no state)
        Delete Forms            -> .deleteForm               (subState: 'delete-form')
        Lock/Unlock             -> .lockUnlock               (subState: 'lock-unlock')
        Enabled/Disabled Forms  -> .enabledDisabled          (subState: 'enabled-disabled')
        Unlock Validation       -> .unlockValidation         (subState: 'unlock-validation')
        Form/Elements Report    -> .formElementsReport       (subState: 'formelements-report')
        Amend/Superseded        -> .amendSupersededReturns   (subState: 'amendsuperseded-returns')
        Efile Scrubbing         -> .efileScrubbing           (subState: 'efile-scrubbing')
        Xml Generation          -> .keyXmlGen                (subState: 'key-xml-gen')
        Xml Comparison          -> .xmlCompare              (subState: 'xml-compare')
    -->
    <!-- Add/Edit hides this shell via `applySubmissionSidebarHidden`; chevron on `gtw-efile-add-edit` restores it. -->
    <div id="sidebar-container" class="sidebar-expanded d-md-block">
      <div class="sidebar-toolbar">
        <span class="Appkit4-icon icon-menu-fill icon-menu-outline sidebar-menu-icon" aria-hidden="true"></span>
        <div class="sidebar-search menu-collapsed">
          <span class="Appkit4-icon icon-search-outline"></span>
          <input type="text" placeholder="" [(ngModel)]="listName" />
        </div>
      </div>
      <ul class="legacy-menu menu-collapsed" role="listbox">
        @for (item of visibleMenuItems; track $index) {
        <li class="legacy-menu-item" [class.selected]="!item.action && isSelected(item.menuKey)" [attr.role]="'option'"
          [attr.aria-selected]="!item.action && isSelected(item.menuKey)" tabindex="0" (click)="onMenuClick(item)"
          (keyup.enter)="onMenuClick(item)">
          {{ item.label }}
          @if (item.action === 'download-8453' && downloading8453) {
          <i class="fa fa-spinner fa-spin sidebar-spinner"></i>
          }
          @if (item.action === 'download-8879' && downloading8879) {
          <i class="fa fa-spinner fa-spin sidebar-spinner"></i>
          }
        </li>
        }
      </ul>
    </div>
    <div class="main-content">
      <!--
        Inline sub-state rendering — replaces the old `<router-outlet>`.
        `subState` comes from `SubmissionDataComponent.activeSubState`,
        which is sourced from the URL (`:subState` segment of
        `/submissions-dasboard/submission/:id/:subState`). Each case
        maps 1:1 to a legacy `submissions-dasboard.submission.<state>`
        ui-router child (see `ui/app/components/efile/efile.js`).
      -->

      @switch (subState) {
      @case ('dashboard') {
      <gtw-efile-elements-dashboard [submission]="submission" [taxYear]="taxYear"></gtw-efile-elements-dashboard>
      }
      <!--
          `submit` (legacy `submissions-dasboard.submission.submit`,
          efile.js L94) → render `gtw-efile-submit-action` which mirrors
          the legacy submit.html + IRS Submissions Status grid (TEST /
          PRODUCTION radio, Submit / Get Ack / Ping IRS, refresh, search,
          per-row download links, Reject / Complete Review actions).
          The earlier `<efile-submit>` was the trimmed prototype with no
          history grid and is intentionally retired here.
        -->
      @case ('submit') {
      <gtw-efile-submit-action [submission]="submission"
        (requestSubStateNav)="subStateChange.emit($event)"></gtw-efile-submit-action>
      }
      @case ('return-review') {
      <gtw-efile-return-review [submission]="submission" [childSubState]="childSubState"></gtw-efile-return-review>
      }
      <!--
          Validation step (legacy `submissions-dasboard.submission.errors`,
          ui/app/components/efile/efile.js L142-148). The migrated
          `gtw-efile-validation-errors` already ports
          `data/errors.html` + `DataErrorsController`; it pulls the
          active submission from `SubmissionService` so no bindings are
          required here. `step` is optional and stays null in this host.
        -->
      @case ('validation') {
      <gtw-efile-validation-errors></gtw-efile-validation-errors>
      }
      @case ('efile-scrubbing') {
      <gtw-efile-scrubbing [childSubState]="childSubState"></gtw-efile-scrubbing>
      }

      <!--
          Add/Edit: entity hierarchy lives in `gtw-efile-add-edit` (left aside);
          `gtw-efile-elements-data` (tabs + projected form) is nested inside add-edit
          so the hierarchy sits outside the data tab pane.
        -->
      @case ('add-edit') {
      <gtw-efile-add-edit [activeTab]="'data'"
        [submissionMenuOpen]="addEditSubmissionMenuOpen"
        (submissionMenuOpenChange)="onAddEditSubmissionMenuOpenChange($event)"
        (tabChange)="subStateChange.emit($event)">
      </gtw-efile-add-edit>
      }
      @case ('efile-data') {
      <gtw-efile-add-edit [activeTab]="'data'"
        [submissionMenuOpen]="addEditSubmissionMenuOpen"
        (submissionMenuOpenChange)="onAddEditSubmissionMenuOpenChange($event)"
        (tabChange)="subStateChange.emit($event)">
      </gtw-efile-add-edit>
      }
      @case ('pdf-upload') {
      <gtw-pdf-upload></gtw-pdf-upload>
      }
      @case ('overrides') {
      <gtw-efile-overrides [submission]="submission" [taxYear]="taxYear"
        [submissionType]="submissionType"></gtw-efile-overrides>
      }
      @case ('xml-upload') {
      <gtw-xml-consol-upload></gtw-xml-consol-upload>
      }

      @case ('key-xml-gen') {
      <gtw-efile-key-xml-gen></gtw-efile-key-xml-gen>
      }
      @case ('xml-compare') {
      <gtw-efile-xml-compare [submission]="submission"></gtw-efile-xml-compare>
      }
      @case ('delete-form') {
      <gtw-efile-delete-form></gtw-efile-delete-form>
      }
      @case ('lock-unlock') {
      <gtw-efile-lock-unlock></gtw-efile-lock-unlock>
      }
      @case ('xml-sync') {
      <gtw-efile-xml-sync [submission]="submission"></gtw-efile-xml-sync>
      }
      @case ('amendsuperseded-returns') {
      <gtw-amend-superseded-returns></gtw-amend-superseded-returns>
      }
      <!--
          Three legacy sibling states co-host the same `gtw-efile-setup`
          tab surface (`efile.js` L186/L200/L207). The sidebar pre-selects
          the corresponding tab via `[initialTab]`.
        -->
      @case ('enabled-disabled') {
      <gtw-efile-setup [initialTab]="'enabled-disabled'"></gtw-efile-setup>
      }
      @case ('unlock-validation') {
      <gtw-efile-setup [initialTab]="'unlock-validation'"></gtw-efile-setup>
      }
      @case ('formelements-report') {
      <gtw-efile-setup [initialTab]="'formelements-report'"></gtw-efile-setup>
      }

      @default {
      <div class="submission-detail-pending">
        <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
        <span>Loading…</span>
      </div>
      }
      }

    </div>
  </div>
</div>